import {
  EquipmentDeleteRequest,
  equipmentDelete,
} from "@/api/delete-equipment";
import { EQUIPMENT_QUERY_KEY } from "@/lib/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export function useDeleteEquipment() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (request: EquipmentDeleteRequest) => {
      const result = await equipmentDelete(request);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al eliminar el equipo", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      toast.success("Equipo eliminado exitosamente", {
        description: result.val,
      });

      queryClient.invalidateQueries({
        queryKey: [EQUIPMENT_QUERY_KEY],
      });

      // return true to indicate that data is a truthy value
      return result.val;
    },
  });
}
